import type { ITopLevelAnalytic } from '~/types/analytic'
import type { IAppSummary } from '~/types/application'

import config from '~/config'
import { request } from '~/utils/request'

//////////////// APPLICATION ////////////////

export const getAppSummary = (appId: string): Promise<IAppSummary> => {
  return request<IAppSummary>({
    url: `${config.VERSIONS_API}/application/${appId}/summary`,
  })
}

export const getAppSummaryByAppKeyDeviceType = (appKey: string, deviceType: string): Promise<IAppSummary> => {
  return request<IAppSummary>({
    url: `${config.VERSIONS_API}/application/${appKey}/device/${deviceType}/summary`,
  })
}

//////////////// ANALYTICS ////////////////

export const getTopLevelAppAnalytics = (appId: string | undefined, uiFeature: string): Promise<ITopLevelAnalytic> => {
  return request<ITopLevelAnalytic>({
    data: {},
    method: 'POST',
    url: `${config.VERSIONS_API}/application/${appId}/analytics/top-level/${uiFeature}`,
  })
}
